import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./ForgotPassword.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JejakinLogo from "./../../../images/jejakin-marketplace.svg";
import JejakinLogoIcon from "./../../../images/jejakin-marketplace-icon.svg";
import { register } from "./../../../serviceWorker";
import { withTranslation } from "react-i18next";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaderButton: false,
      email: null,
    };
  }

  forgotPassword = (e) => {
    e.preventDefault();
    this.setState({ loaderButton: true });
    let data = {
      email: this.state.email,
    };
    axios({
      method: "POST",
      url: "/user/forgot-password",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    }).then(
      (response) => {
        console.log("response data forgot ", response.data);
        if (response.data.status === true) {
          toast.success(
            "Sukses! Silahkan cek email anda untuk mengubah password!"
          );
          setTimeout(() => {
            this.setState({ loaderButton: false });
          }, 1000);
        } else {
          if (response.data.error.length) {
            for (var er = 0; er < response.data.error.length; er++) {
              var obj = response.data.error[er];
              for (var key in obj) {
                console.log(key, obj[key]);
                toast.error(key + " : " + obj[key]);
              }
              this.setState({ loaderButton: false });
            }
          } else {
            this.setState({ loaderButton: false });
            toast.error(response.data.error);
          }
        }
      },
      (error) => {
        toast.error("Error! " + error);
        setTimeout(() => {
          this.setState({ loaderButton: false });
        }, 1000);
      }
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className="mpl-page">
          <ToastContainer />
          <div className="wrap-account">
            <div className="wp-ac wrap-left">
              <div className="logo-fixed">
                <Link to="/">
                  <img src={JejakinLogo} alt="Jejakin" />
                </Link>
              </div>
              <div className="wp-login">
                {/* <h2>{this.props.t("ForgotPassword.header")}</h2> */}
                <div className="row">
                  <div className="col-auto">
                    <h3 className="ts-underline mb-5">
                      {this.props.t("ForgotPassword.link_lupa")}
                    </h3>
                  </div>
                  <div className="col-auto">
                    <h3 className="ts-underline no-bg mb-5">
                      <Link to="/login">
                        {this.props.t("ForgotPassword.link_masuk")}
                      </Link>
                    </h3>
                  </div>
                </div>
                <form id="formForgot" onSubmit={this.forgotPassword}>
                  <div className="form-group">
                    <label htmlFor="email" className="label-group">
                      {this.props.t("ForgotPassword.label_email")}
                    </label>
                    <input
                      id="email"
                      type="text"
                      className="field-group"
                      name="email"
                      onChange={(e) => this.setState({ email: e.target.value })}
                      value={this.state.email || ""}
                    />
                    <div className="mt-1">
                      <small>{this.props.t("ForgotPassword.help_email")}</small>
                    </div>
                  </div>

                  <div className="form-group mb-0">
                    <button className="btn btn-green ">
                      {this.state.loaderButton === true ? (
                        <span>
                          <i className="fa fa-spin fa-spinner"></i>{" "}
                          {this.props.t("ForgotPassword.btn_tunggu")}
                        </span>
                      ) : (
                        this.props.t("ForgotPassword.btn_kirim")
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="wp-ac wrap-right">
              <div className="green-ov">&nbsp;</div>
              <div className="content-highlight">
                <h2>{this.props.t("ForgotPassword.quote")}</h2>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(ForgotPassword);
